import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      players: {
        list_players: {
          view_player: {
            save: 'PLAYER_DETAILS_SAVE',
            tabs: {
              tracker_player: {
                anid: 'ANID',
                date: 'DATE',
                serial_id: 'SERIAL_ID',
                incoming_url: 'INCOMING_URL',
                history_changes_players: {
                  edit: {
                    header: 'HISTORY_CHANGES_PLAYER',
                    save: 'HISTORY_CHANGES_SAVE',
                    close: 'HISTORY_CHANGES_CLOSE',
                    form: {
                      serial_id: 'HISTORY_CHANGES_SERIAL_ID',
                      anid: 'HISTORY_CHANGES_AN_ID',
                      date: 'HISTORY_CHANGES_DATE',
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  }));
}
